/**
 * /*
 * Filter Active Item
 *
 * Show one filter item in the active filters list
 *
 * @format
 */

import React from 'react';
import Moment from 'moment';

export default class extends React.Component {
    render() {
        return (
            <>
                <div
                    role="button"
                    data-index={this.props.index}
                    onClick={this.props.onRemove}
                    className="badge text-bg-primary tag-saved-search active-filter">
                    {this.props.name} = {this._getFilterValue()}{' '}
                    <span className="d-inline-block tw-ml-2">&#10005;</span>
                </div>
                {this.props.index < this.props.totalFilters - 1 && (
                    <div className="badge badge-outline-secondary tw-ml-2 mr-2">And</div>
                )}
            </>
        );
    }

    /**
     * Get the value for a given filter
     * @returns {string}
     * @private
     */
    _getFilterValue = () => {
        let value = '';

        if (this.props.type == 'date_range') {
            value = this.props.value.split(',');
            if (value.length == 2) {
                value = value.map(date => Moment(date).format('MM/DD/YYYY')).join(' - ');
            } else if (typeof this.props.intervals != 'undefined') {
                value = this.props.intervals.filter(interval => {
                    return interval.value == value[0];
                });

                if (value.length > 0) {
                    value = value[0].label;
                } else {
                    value = this.props.value;
                }
            } else {
                value = this.props.value;
            }
        } else {
            value = this.props.value;
        }

        if (this.props.type == 'select') {
            value = this.props.options.find(option => option.id == value).name;
        }

        return value;
    };
}
